import { appRoute } from '@aex/ngx-toolbox';

export const APP_ROUTES = {
	login: appRoute('login'),
	landing: appRoute('landing'),
	checkout: appRoute('checkout'),
	register: appRoute('register'),
	doorhanger: appRoute('smi'),
	registerContractor: appRoute('register-contractor'),
	coverage: appRoute('coverage'),
	dashboard: appRoute('dashboard'),
	// portal: appRoute('portal'),
	products: appRoute('products'),
	premise: appRoute('premise'),
	schedule: appRoute('schedule'),
	quote: appRoute('quote'),
	showInterest: appRoute('show-interest'),
	device: appRoute(':type/:serialNumber'),
	serial: appRoute(':type/:serialNumber'),
	forgot: appRoute('forgot'),
	shop: appRoute('shop'),
	support: appRoute('support'),
	firstPurchase: appRoute('first-purchase'),
	serviceAccount: appRoute('service-account'),
	wifiDetails: appRoute('wifi-details'),
	cardDetails: appRoute('card-details'),
	debitDays: appRoute('debit-days'),
	paymentMediums: appRoute('payment-mediums'),
	walledGardenLanding: appRoute('limited-landing'),
	rica: appRoute('rica'),
	stripeSaved: appRoute('stripe-saved'),
	thankYou: appRoute('thank-you'),
	wifiManagement: appRoute('wifi-management'),
	accountConfirmation: appRoute('account-confirmation'),
	accountSetup: appRoute('account-setup'),
	passwordReset: appRoute('password-reset'),
	backOffice: appRoute('back-office'),
	externalPaymentResult: appRoute('ext-pay'),
	orderSuccess: appRoute('order-success'),
	addressManagement: appRoute('address-management'),
	automatedActions: appRoute('automated-actions'),
	customers: appRoute('customers'),
};

export const BACK_OFFICE_ROUTES = {
	controls: appRoute('controls'),
	paymentManagement: appRoute('payment-management'),
	rulesEngine: appRoute('rules-engine'),
	knox: appRoute('knox'),
	security: appRoute('security'),
	notifications: appRoute('notifications'),
	portal: appRoute('portal'),
	promotions_and_discounts: appRoute('promotions-and-discounts'),
	// layout: appRoute('layout'),
};

export const ADDRESS_MANAGEMENT = {
	clientPremises: appRoute('client-premises'),
	predefinedPremises: appRoute('predefined-premises'),
	predefinedPremisesStatus: appRoute('predefined-premises-status'),
	predefinedPremisesAreaManagement: appRoute('predefined-premises-area-management'),
	clientPremisesBulkImportEnquiry: appRoute('client-premises/bulk-import-enquiry'),
	clientPremisesImportQueueEnquiry: appRoute('client-premises/import-enquiry-queue/:id'),
};

export const AUTOMATED_ACTIONS = {
	rules: appRoute('rules'),
	ruleSetup: appRoute('rule-setup'),
	newRule: appRoute('new-rule'),
	editRule: appRoute('edit-rule'),
	ruleDetails: appRoute('rule-details'),
	editConditions: appRoute('edit-conditions'),
	editSteps: appRoute('edit-steps'),
	configuration: appRoute('configuration'),
	scheduleRule: appRoute('schedule-rule'),
};

export const CONTROLS = {
	bulkServices: appRoute('bulk-services'),
	scheduler: appRoute('scheduler'),
	testRedirect: appRoute('payment-medium-capture/:serviceId'),
};

export const PAYMENT_MANAGEMENT = {
	firstPurchase: appRoute('first-purchase'),
	paymentMediums: appRoute('payment-mediums'),
	stripeSaved: appRoute('stripe-saved'),
	externalPaymentResult: appRoute('ext-pay'),
	paymentDetails: appRoute('payment-details'),
	portalPaymentHistory: appRoute('portal-payment-history'),
};

export const RULES_ENGINE = {
	billingSchemeConfig: appRoute('billing-scheme-config'),
};

export const NOTIFICATIONS = {
	landingPage: appRoute('landing-page'),
	requestList: appRoute('request-list'),
};

export const PORTAL = {
	loginPage: appRoute('login'),
	forgotPassword: appRoute('forgot-password'),
	checkEmail: appRoute('check-email'),
	resetPassword: appRoute('reset-password'),
	faq: appRoute('faq'),
	dashboardPage: appRoute('dashboard'),
	customerPage: appRoute('customer-old'),
	devices: appRoute('devices'),
	taskPage: appRoute('tasks'),
	manageProfilePage: appRoute('manage-profile'),
	automatedInsights: appRoute('automated-insights'), // todo:portal2 - vaughn
};
export const DASHBOARD_TABS = {
	services: appRoute('services'),
	newOrders: appRoute('new-orders'),
	changes: appRoute('changes'),
	cancellations: appRoute('cancellations'),
	support: appRoute('support'),
	others: appRoute('others'),
	unassignedDevices: appRoute('unassigned-devices'),
};

//#todo:portal2 - fix url need to figure out customers/ in module route
export const CUSTOMER_ROUTES = {
	view: appRoute('customers/view'), //#todo:portal2 - should be customers (old view is using customers
	addCustomerPage: appRoute('customers/add'),
	detailPage: appRoute('customers/:id'),
	// routes above both hashone and new
	manageCustomer: appRoute('customers/manage-customer'),
};

export const WORK_ORDERS_ROUTES = {
	view: appRoute('tasks/view'), //#todo:portal2 - should be customers (old view is using customers
	// addCustomerPage: appRoute('tasks/add'),
	// detailPage: appRoute('tasks/:id'),
};

export const PROMO_AND_DISCOUNT_ROUTES = {
	promotionsAndDiscounts: appRoute('promotions-and-discounts'),
	managePromotionsAndDiscounts: appRoute('manage-promotions-and-discounts'),
	addBulkPromotionsAndDiscounts: appRoute('add-bulk-promotions-and-discounts'),
	deleteBulkPromotionsAndDiscounts: appRoute('delete-bulk-promotions-and-discounts'),

	promoReportSummary: appRoute('promo-report-overview-promotion'),
	promoReportSummaryService: appRoute('promo-report-overview-service'),
	promoReportSummaryServicePurchase: appRoute('promo-report-overview-invoice'),
	promoReportSummaryServicePurchaseInfo: appRoute('promo-report-summary-service-purchase-info'),

	manageServicePromotion: appRoute('manage-service-promo'),

	boltOns: appRoute('bolt-ons'),
	manageBoltOn: appRoute('manage-bolt-on'),
	addBulkBoltOns: appRoute('add-bulk-bolt-ons'),
	deleteBulkBoltOns: appRoute('delete-bulk-bolt-ons'),

	boltOnReportSummary: appRoute('bolt-on-report-overview-bolt-on'),
	boltOnReportSummaryService: appRoute('bolt-on-report-overview-service'),
	boltOnReportSummaryServicePurchase: appRoute('bolt-on-report-overview-invoice'),
	boltOnReportSummaryServicePurchaseInfo: appRoute('bolt-on-report-summary-service-purchase-info'),

	manageServiceBoltOn: appRoute('manage-service-bolt-on'),

}

export const PORTAL_ROUTES = {
	home: {
		title: 'Home',
		route: appRoute('dashboard'),
	},
	customers: {
		title: 'Customers (Services)',
		route: appRoute('customers/customers'),
	},
	tasks: {
		title: 'Tasks (Work Orders)',
		route: appRoute('tasks'),
	},
	pmo: {
		title: 'PMO', // no route (topmost menu with child menu items - these have routes)
	},
	automatedInsights: {
		title: 'Automated Insights',
		route: appRoute('automated-insights'),
	},
	network: {
		title: 'Network', // no route (topmost menu with child menu items - these have routes)
	},
	devices: {
		title: 'Devices',
		route: appRoute('devices'),
	},
	admin: {
		title: 'Admin', // no route (topmost menu with child menu items - these have routes)
	},
};
